import React from "react";
import Search, {SearchInputType} from '@components/custom/Search';
import {SelectionMode, IntervalOptions, Interval} from '@models/index';
import {SubscriptionStatus, SubscriptionStatusOptions} from "@models/subscription";
import {PaymentGatewayOptions} from '@models/paymentGateway';
import __i18n from "../../../intl/__i18n";
import {REGEX_PATTERNS} from '../../../constants/regex';


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
  intl: any;
}

const SubscriptionsReportSearch: React.FC<SearchInputProps> = props => {
  const {search} = props;
  
  const inputs = [{
    name: "msisdn",
    label: __i18n("Mobile Number"),
    size: 12,
    type: SearchInputType.TEXT,
    validationRules:[{
      pattern: REGEX_PATTERNS.MOBILE,
      message: __i18n("{value} is not valid.", {
        value : __i18n("Value")
      })
    }],
    InputProps:{
      placeholder : "98912111111"
    }
  },{
    name: "term",
    label: __i18n("Name"),
    type: SearchInputType.SELECT,
    options: IntervalOptions,
    selectionType : SelectionMode.DEFAULT,
    size: 12,
    InputProps:{
      defaultValue : Interval.Hour
    }
  }];
  
  return(
    <Search
      inputs={inputs}
      search={search}
      hasClearButton={true}
      searchOnChange={false}/>
  )
};


export default SubscriptionsReportSearch;